import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { aggregatedActivityActions } from 'store/aggregated/aggregatedActivity';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches aggregated activity rows at Activity resolution and loads the aggregatedActivity domain.
// Gated behind JwtFeature.Activity.
export function* initializeAggregatedActivities() {
  function* work(tenantId: string) {
    const {
      aggregatedActivityDomain,
    }: SagaReturnType<typeof api.getAggregatedActivities> = yield call(
      api.getAggregatedActivities,
      { tenantId, resolution: 'Activity' },
    );

    yield put(aggregatedActivityActions.setDomain(aggregatedActivityDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Activity);
}
